import { z } from 'zod';
import { DeviceName } from './installer.ts';
import { ChargeMode } from './modes.ts';

// What owners and members see and may operate (ADR-0020). Installers and admins always see
// and operate everything.

export const CUSTOMER_PAGES = ['charging', 'heatpump', 'battery', 'grid', 'history'] as const;
export const CustomerPage = z.enum(CUSTOMER_PAGES);
export type CustomerPage = z.infer<typeof CustomerPage>;

const locks = {
  /** charge limit, charging plan and vehicle selection */
  lockTargets: z.boolean().default(false),
  /** heat pump mode and minimum temperature */
  lockHeatPump: z.boolean().default(false),
  lockBattery: z.boolean().default(false),
  /** prices (ADR-0018) */
  lockPrices: z.boolean().default(false),
};

/** as stored and edited in the installer area */
export const CustomerViewSettings = z.object({
  hiddenPages: z.array(CustomerPage).max(CUSTOMER_PAGES.length).default([]),
  /** fixed charge mode by charger name; listed wallboxes cannot change their mode */
  fixedModes: z.record(DeviceName, ChargeMode).default({}),
  ...locks,
  updatedAt: z.string().optional(),
});
export type CustomerViewSettings = z.infer<typeof CustomerViewSettings>;

/** for the app: fixed modes by loadpoint id; restricted = the settings apply to the viewer */
export const CustomerView = z.object({
  hiddenPages: z.array(CustomerPage),
  fixedModes: z.record(z.string(), ChargeMode),
  ...locks,
  restricted: z.boolean(),
});
export type CustomerView = z.infer<typeof CustomerView>;
